import { ImportarActivosExcelCommandProps } from "api/Commands/ImportarActivosExcelCommand"
import { TipoInmovilizadoType } from "api/Types/TipoInmobilizado"
import { TipPeriodoType } from "api/Types/TipoPeriodo"
import { backendDateFormat } from "utils/formatDate"

export interface ActivosExcelProps {
  nombre: string | null
  fechaAdquisicion: string
  contactoNif: string | null
  contactoNombre: string | null
  tipoInmovilizado: TipoInmovilizadoType
  importe: number
  importePendiente: number
  cuentaContableActivo: string | null
  cuentaContableContrapartida: string | null
  conceptoTablaAmortizacion: string | null
  informacionAmortizacionTipoPeriodo: TipPeriodoType
  informacionAmortizacionCoeficiente: number
  informacionAmortizacionAnyos: number
  informacionAmortizacionCuentaContableAmortizacionAcumulada: string | null
  informacionAmortizacionCuentaContableAmortizacionGasto: string | null
  fechaInicioAmortizacion: string
  descripcion: string | null
  numeroSerie: string | null
  numeroInventario: string | null
  codigoBarras: string | null
  marca: string | null
  esAmortizable: string | null
}

export const mapActivosImportar = (
  data?: ActivosExcelProps[] | null
): ImportarActivosExcelCommandProps | void => {
  try {
    return {
      activos: data
        ? data?.map((activo: ActivosExcelProps) => ({
            nombre: activo.nombre,
            fechaAdquisicion: activo?.fechaAdquisicion
              ? backendDateFormat(new Date(activo.fechaAdquisicion))
              : null,
            contacto: {
              nif: activo.contactoNif,
              nombre: activo.contactoNombre,
            },
            tipoInmovilizado: activo.tipoInmovilizado,
            importe: activo.importe,
            importePendiente: activo.importePendiente,
            cuentaContableActivo: activo.cuentaContableActivo,
            cuentaContableContrapartida: activo.cuentaContableContrapartida,
            informacionAmortizacion:
              activo?.esAmortizable?.toLowerCase() === "si"
                ? {
                    conceptoTablaAmortizacion: activo.conceptoTablaAmortizacion,
                    tipoPeriodo: activo.informacionAmortizacionTipoPeriodo,
                    coeficiente: activo.informacionAmortizacionCoeficiente,
                    anyos: activo.informacionAmortizacionAnyos,
                    cuentaContableAmortizacionAcumulada:
                      activo.informacionAmortizacionCuentaContableAmortizacionAcumulada,
                    cuentaContableAmortizacionGasto:
                      activo.informacionAmortizacionCuentaContableAmortizacionGasto,
                    fechaInicioAmortizacion: activo?.fechaInicioAmortizacion
                      ? backendDateFormat(
                          new Date(activo.fechaInicioAmortizacion)
                        )
                      : null,
                  }
                : null,
            descripcion: activo.descripcion,
            numeroSerie: activo.numeroSerie,
            numeroInventario: activo.numeroInventario,
            codigoBarras: activo.codigoBarras,
            marca: activo.marca,
            esAmortizable: activo?.esAmortizable?.toLowerCase() === "si",
          }))
        : null,
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
}
